import {DomainObject} from 'shared/store';
import { computed, observable, action, makeObservable } from 'mobx';
import PerformanceReviewCycle from './PerformanceReviewCycle';
import PerformanceReviewType from './PerformanceReviewType';
import PerformanceReviewReviewee from './PerformanceReviewReviewee';
import PerformanceReviewAnswer from './PerformanceReviewAnswer';
import Employee from 'main/stores/employees/Employee';
import _ from 'lodash';
import PerformanceReviewNote from 'main/stores/performance_reviews/PerformanceReviewNote';
import {auth} from 'main/tools';

class PerformanceReviewReview extends DomainObject {
  id;
  cycle;
  type;
  reviewee;
  reviewer;
  answers = [];
  submitted;
  submittedAt;
  sharedAt;
  notes = [];

  _relations = {
    cycle: PerformanceReviewCycle,
    type: PerformanceReviewType,
    reviewer: Employee,
    reviewee: PerformanceReviewReviewee,
    answers: [PerformanceReviewAnswer],
    notes: [PerformanceReviewNote]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      cycle: observable,
      type: observable,
      reviewee: observable,
      reviewer: observable,
      answers: observable,
      submitted: observable,
      submittedAt: observable,
      sharedAt: observable,
      notes: observable,
      readOnly: computed,
      canUnsubmit: computed,
      isManagerReview: computed,
      sortedAnswers: computed,
      regenerateAnswersForQuestions: action,
      currentUserIsReviewee: computed
    });

    this.merge(other);
  }

  get readOnly() {
    return !this.hasLink('submit');
  }

  get canUnsubmit() {
    return this.hasLink('unsubmit');
  }

  get isManagerReview() {
    return this.type.kind === 'manager';
  }

  get sortedAnswers() {
    return _.orderBy(this.answers, ['question.order'], ['asc']);
  }

  regenerateAnswersForQuestions(questions) {
    let newAnswers = [];
    let currentAnswers = _.keyBy(this.answers, 'question.id');

    _.forEach(questions, q => {
      let answer = new PerformanceReviewAnswer({question: q});
      if (currentAnswers[q.id] !== undefined) {
        answer.value = currentAnswers[q.id].value;
      }
      newAnswers.push(answer);
    });

    this.answers = newAnswers;
  }

  get currentUserIsReviewee() {
    return auth.employee.id === this.reviewee.employee.id;
  }
}

export default PerformanceReviewReview;
